class Cart extends HTMLElement {
  constructor() {
    super();
    this.handleToggleDrawerCart();
    this.handleQuantityFields();
    this.handleAddToCart();
  }

  handleToggleDrawerCart() {
    document.querySelectorAll(".js-open-drawer-cart").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        document.querySelector(".js-drawer-cart")?.classList.add("display");
        setTimeout(() => {
          document.querySelector(".js-drawer-cart")?.classList.add("active");
        }, 50);
        this.loadDrawerCartScripts();
      });
    });

    document.querySelectorAll(".js-close-drawer-cart").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        document.querySelector(".js-drawer-cart")?.classList.add("closing");
        setTimeout(() => {
          document
            .querySelector(".js-drawer-cart")
            ?.classList.remove("active", "closing", "display");
        }, 300);
      });
    });
  }

  loadDrawerCartScripts() {
    if (
      !this.drawerCartScriptsLoaded &&
      typeof drawerCartScripts !== "undefined" &&
      Array.isArray(drawerCartScripts)
    ) {
      drawerCartScripts.forEach((scriptSrc) => {
        if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
          let script = document.createElement("script");
          script.src = scriptSrc;
          script.async = true;
          document.body.appendChild(script);
        }
      });
      this.drawerCartScriptsLoaded = true;
    }
  }

  handleQuantityFields() {
    document.body.addEventListener("click", (event) => {
      const target = event.target.closest(".js-change-quantity");
      if (!target) return;

      event.preventDefault();

      target.classList.add("loading");

      const variantId = parseInt(target.getAttribute("data-variant-id"), 10);
      let quantity = parseInt(target.getAttribute("data-quantity"), 10);
      const container = target.closest(".js-quantity-fields");

      container
        .querySelector(".js-quantity-minus")
        .setAttribute("data-quantity", quantity - 1);
      container
        .querySelector(".js-quantity-plus")
        .setAttribute("data-quantity", quantity + 1);

      const cartItem = container.closest(".js-cart-item");
      cartItem.style.height = `${cartItem.offsetHeight}px`;

      var formData = new FormData();
      formData.append("updates[" + variantId + "]", quantity);

      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          document
            .querySelectorAll(".js-change-quantity")
            .forEach((el) => el.classList.remove("loading"));
          const subtotalElement = document.querySelector(".js-subtotal-price");
          if (subtotalElement) {
            subtotalElement.innerHTML = Shopify.formatMoney(
              response.total_price
            );
          }

          if (quantity < 1) {
            cartItem.classList.add("hide-item");
            setTimeout(() => {
              cartItem.classList.add("hidden");
              if (response.total_price === 0) {
                document
                  .querySelector(".js-cart-content")
                  .classList.add("drawer-cart__content--empty");
              }
            }, 300);
          } else {
            container.querySelector(".js-quantity-field-input").value =
              quantity;
          }

          const freeDelivery = document.querySelector(".js-free-delivery");
          if (freeDelivery) {
            let width = 0;
            const limit = parseInt(freeDelivery.getAttribute("data-limit"));
            let price = Shopify.formatMoney(0);

            if (response.total_price >= limit) {
              width = 100;
              freeDelivery.classList.add("active");
            } else {
              freeDelivery.classList.remove("active");
              if (response.total_price > 0) {
                width = (response.total_price / limit) * 100;
                price = Shopify.formatMoney(limit - response.total_price);
                document.querySelector(".js-cart-spend-more-money").innerHTML =
                  freeDelivery
                    .getAttribute("data-spend-more-text")
                    .replace("[price]", price);
              }
            }
            document.querySelector(
              ".js-free-delivery-bar"
            ).style.width = `${width}%`;
          }

          document
            .querySelectorAll(".js-cart-counter")
            .forEach((cartCounter) => {
              cartCounter.innerHTML = response.item_count;
              cartCounter.setAttribute("data-counter", response.item_count);
            });
        })
        .catch((error) => {
          alert(error.message || "Error");
          document
            .querySelectorAll(".js-change-quantity")
            .forEach((el) => el.classList.remove("loading"));
        });
    });
  }

  handleAddToCart() {
    document.body.addEventListener("click", function (event) {
      const target = event.target.closest(".js-add-to-cart");
      if (!target) return;

      event.preventDefault();

      const span = target.querySelector("span");
      if (span) {
        span.innerHTML = target.getAttribute("data-adding-text");
      }
      target.classList.add("loading");

      let quantity,
        id,
        properties = {};

      let productId = target.getAttribute("data-product-id");
      let productElement = document.querySelector(
        `.js-product[data-product-id='${productId}']`
      );
      quantity = productElement
        ? productElement.querySelector(".js-quantity-field").value
        : 1;
      if (isNaN(quantity) || !quantity) quantity = 1;
      id = productElement
        ? productElement.querySelector(`#product-select-${productId}`).value
        : target.getAttribute("data-variant-id");

      let formData = {
        items: [
          {
            id: parseInt(id, 10),
            quantity: parseInt(quantity, 10),
          },
        ],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            document.querySelectorAll(".js-add-to-cart").forEach((button) => {
              const originalText = button.getAttribute("data-original-text");
              const span = button.querySelector("span");
              if (originalText) {
                span.textContent = originalText;
              }
            });
            return response.json().then((err) => {
              throw err;
            });
          }
          return response.json();
        })
        .then((response) => {
          response = response.items.find(
            (item) => item.id === parseInt(id, 10)
          );
          let variantId = response.variant_id;
          let cartItem = document.querySelector(
            `.js-cart-item[data-variant-id='${variantId}']:not(.hidden)`
          );

          if (cartItem) {
            let quantityField = cartItem.querySelector(
              ".js-quantity-field-input"
            );
            let quantityMinus = cartItem.querySelector(".js-quantity-minus");
            let quantityPlus = cartItem.querySelector(".js-quantity-plus");

            quantityField.value = response.quantity;
            quantityMinus.setAttribute("data-quantity", response.quantity - 1);
            quantityPlus.setAttribute("data-quantity", response.quantity + 1);
          } else {
            let options = "";
            if (
              response.options_with_values &&
              response.options_with_values.length > 0
            ) {
              response.options_with_values.forEach((option) => {
                if (option.name !== "Title") {
                  options += `<div class="cart-item__option">${option.value}</div>`;
                }
              });
            }
            let quantityMinus = response.quantity - 1;
            let quantityPlus = response.quantity + 1;

            let featuredImage = target.getAttribute("data-featured-image");
            let productImage =
              featuredImage && featuredImage.trim() !== ""
                ? featuredImage
                : response.image;

            let item = `
					<li class="cart-item d-flex js-cart-item" data-variant-id="${
            response.variant_id
          }">
					  <div class="cart-item__image">
					    <a href="${response.url}">
                <img 
                    src="${productImage}" 
                    srcset="${productImage}" 
                    sizes="200px" 
                    alt="${response.product_title}" 
                    loading="lazy" 
                    width="200" 
                    height="276" 
                    class="fade-in" />
					    </a>
					  </div>
					  <div class="cart-item__details">
					    <div class="cart-item__title"><a href="${response.url}">${
              response.product_title
            }</a></div>
              ${(response.options_with_values || [])
                .filter((option) => option.name !== "Title")
                .map(
                  (option) =>
                    `<div class="cart-item__option">${option.name}: ${option.value}</div>`
                )
                .join("")}
					    <div class="cart-item__price">${Shopify.formatMoney(response.price)}</div>
					    <div class="cart-product__quantity-and-delete d-flex align-items-center js-quantity-fields">
					      <div class="cart-product__quantity-field">
					        <div class="quantity-field__minus">
					          <a href="#" class="js-change-quantity js-quantity-minus" data-variant-id="${
                      response.variant_id
                    }" data-quantity="${response.quantity - 1}">-</a>
					        </div>
					        <input type="text" value="${
                    response.quantity
                  }" class="quantity-field__input js-quantity-field-input" disabled="disabled" />
					        <div class="quantity-field__plus">
					          <a href="#" class="js-change-quantity js-quantity-plus" data-variant-id="${
                      response.variant_id
                    }" data-quantity="${response.quantity + 1}">+</a>
					        </div>
					      </div>
					      <div class="cart-item__delete">
					        <a href="#" class="js-change-quantity" data-variant-id="${
                    response.variant_id
                  }" data-quantity="0">Remove</a>
					      </div>
					    </div>
					  </div>
					</li>`;
            document
              .querySelector(".js-cart-items")
              .insertAdjacentHTML("beforeend", item);
            if (typeof initializeObservers === "function") {
              initializeObservers();
            }
          }

          return fetch(window.Shopify.routes.root + "cart.js").then(
            (response) => response.json()
          );
        })
        .then((cart) => {
          document
            .querySelectorAll(".js-change-quantity")
            .forEach((el) => el.classList.remove("loading"));
          const subtotalElement = document.querySelector(".js-subtotal-price");
          if (subtotalElement) {
            subtotalElement.innerHTML = Shopify.formatMoney(cart.total_price);
          }

          let freeDeliveryElement = document.querySelector(".js-free-delivery");
          if (freeDeliveryElement) {
            let width = 0;
            let limit = parseInt(
              freeDeliveryElement.getAttribute("data-limit")
            );
            let price = Shopify.formatMoney(0);

            if (cart.total_price >= limit) {
              width = 100;
              freeDeliveryElement.classList.add("active");
            } else {
              freeDeliveryElement.classList.remove("active");
              if (cart.total_price > 0) {
                width = (cart.total_price / limit) * 100;
                price = Shopify.formatMoney(limit - cart.total_price);
                document.querySelector(".js-cart-spend-more-money").innerHTML =
                  freeDeliveryElement
                    .getAttribute("data-spend-more-text")
                    .replace("[price]", price);
              }
            }
            document.querySelector(".js-free-delivery-bar").style.width =
              width + "%";
          }

          document
            .querySelector(".js-cart-content")
            ?.classList.remove("drawer-cart__content--empty");
          document
            .querySelectorAll(".js-cart-counter")
            .forEach((cartCounter) => {
              cartCounter.innerHTML = cart.item_count;
              cartCounter.setAttribute("data-counter", cart.item_count);
            });
          document.querySelector(".js-drawer-cart")?.classList.add("display");
          setTimeout(() => {
            document.querySelector(".js-drawer-cart")?.classList.add("active");
          }, 50);
          document.querySelectorAll(".js-add-to-cart").forEach((button) => {
            const originalText = button.getAttribute("data-original-text");
            const span = button.querySelector("span");
            if (originalText) {
              span.textContent = originalText;
            }
          });
        })
        .catch((error) => {
          alert(error.description ? error.description : "Error");
        });
    });
  }
}

customElements.define("drawer-cart", Cart);
